import React from 'react';
import PropTypes from 'prop-types';

import * as styles from './ReviewSites.scss';
import images from '../../../static/images/RealtorLanding';

const ReviewSites = (props) => (
    <div className={styles.wrapper}>
        <p>{props.translate('reviewSites', 'title')}</p>
        <div className={styles.linksWrapper}>
            <a
              className={styles.link}
              href="https://www.calcalist.co.il/articles/0,7340,L-3838340,00.html"
              target="_blank"
              rel="noopener noreferrer"
            >
                <img src={images.calcalist} alt="" />
                <img src={images.theMarkerSample} className={styles.tooltip} alt="" />
            </a>
            <a
              className={styles.link}
              href="https://www.themarker.com/labels/proptech/1.9948109"
              target="_blank"
              rel="noopener noreferrer"
            >
                <img src={images.theMarker} alt="" />
                <img src={images.haaretzSample} className={styles.tooltip} alt="" />
            </a>
            <a
              className={styles.link}
              href="https://www.haaretz.co.il/labels/apps/1.9339560"
              target="_blank"
              rel="noopener noreferrer"
            >
                <img src={images.haaretz} alt="" />
                <img src={images.calcalistSample} className={styles.tooltip} alt="" />
            </a>
        </div>
    </div>
);

ReviewSites.propTypes = {
  translate: PropTypes.func
};

export default ReviewSites;
